export default __webpack_public_path__ + "static/media/evan.444a598e.jpeg";